module.exports = __webpack_public_path__ + "static/media/12.6d4ac185.JPG";